import { DatePipe } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDatepickerInputEvent } from "@angular/material/datepicker";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import Swal from "sweetalert2";
import { GrupoYears } from "../../modelos/modelo-grupo-years.model";
import { OperativoService } from "../../opeartivo.service";

// Angular core y formularios
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

// Angular Material
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule } from "@angular/material/core"; // ⬅ Necesario para que funcione el datepicker con fechas nativas

// Módulo de búsqueda dentro de mat-select
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";

// DataTables para Angular

@Component({
  selector: "app-modal-agregar-nombre-grupos",
  standalone: true,
  templateUrl: "./modal-agregar-nombre-grupos.component.html",
  styleUrls: ["./modal-agregar-nombre-grupos.component.css"],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxMatSelectSearchModule,
    ],
})
export class ModalAgregarNombreGruposComponent {
  agrupacion: FormGroup;
  datosGrupoYears: GrupoYears = new GrupoYears();
  today: Date = new Date();
  minDate: Date;
  minDateVigencia: Date;
  maxDate: Date;
  maxDateVigencia: Date;
  validarAnio: number;
  validarAnio2: number;
  fecha: string = "";

  constructor(
    public dialogRef: MatDialogRef<ModalAgregarNombreGruposComponent>,
    private formBuilder: FormBuilder,
    private datePipe: DatePipe,
    private servicioOperativo: OperativoService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.minDate = new Date(this.today.getFullYear() - 1, 0, 1); // Un año atrás desde hoy
    this.maxDate = new Date(this.today.getFullYear() + 0, 11, 31); // Un año adelante desde hoy
  }
  idPadrePermitido: number;

  ngOnInit(): void {
    this.agrupacion = this.formBuilder.group({
      nombre: ["", Validators.required],
      fecha_alta: [null, Validators.required],
      fecha_vigencia: [{ value: null, disabled: true }],
    });

    this.agrupacion.get("fecha_alta").valueChanges.subscribe((fecha) => {
      if (fecha) {
        const year = fecha.getFullYear();
        this.datosGrupoYears.year_creacion = year;
        this.minDateVigencia = new Date(year, 0);

        if (year < this.today.getFullYear()) {
          this.minDateVigencia = new Date(this.today.getFullYear() - 1, 0, 1);
        }

        this.agrupacion.get("fecha_vigencia").enable();
      }
    });
  }

  onDateChange(event: MatDatepickerInputEvent<Date>) {
    const selectedDate = event.value;
    // Verificar si es un mes antes de que termine el año
    if (
      selectedDate &&
      selectedDate.getMonth() === 11 &&
      selectedDate.getDate() === 31
    ) {
      this.maxDate.setFullYear(this.maxDate.getFullYear() + 1); // Habilitar el año siguiente
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  clear(): void {
    this.agrupacion.reset();
    this.agrupacion.get("fecha_vigencia").disable();
  }

  save(): void {
    this.datosGrupoYears.fecha_alta = this.agrupacion.controls.fecha_alta.value;
    this.datosGrupoYears.fecha_vigencia =
      this.agrupacion.controls.fecha_vigencia.value;
    this.datosGrupoYears.nombre = this.agrupacion.controls.nombre.value;

    // Solo usar los IDs cuando data no existe o es 0
    const idsPadre =
      !this.data || this.data === 0 ? [502, 4, 208] : [this.data];

    let total = idsPadre.length;
    let procesados = 0;
    let exitos = 0;
    let fallos = 0;

    idsPadre.forEach((id) => {
      const payload = { ...this.datosGrupoYears, idPadre: id };
      console.log("Llamando con padre:", id);

      this.servicioOperativo.ValidarRegistrosRepetidos(payload).subscribe({
        next: (res) => {
          if (res.pCodRetorno !== "00000") {
            console.warn("Nombre repetido en idPadre", id);
            fallos++;
            procesarFin();
          } else {
            this.servicioOperativo.saveGrupoYears(payload).subscribe({
              next: (resp) => {
                if (resp.pCodRetorno === "00000") {
                  console.log("Guardado OK en idPadre", id);
                  exitos++;
                } else {
                  console.error("Error guardando en idPadre", id);
                  fallos++;
                }
                procesarFin();
              },
              error: () => {
                fallos++;
                procesarFin();
              },
            });
          }
        },
        error: () => {
          fallos++;
          procesarFin();
        },
      });
    });

    const procesarFin = () => {
      procesados++;

      if (procesados === total) {
        if (exitos > 0) {
          Swal.fire({
            title: "Éxito",
            html: `<p>Se guardaron ${exitos} grupo(s) correctamente.</p>`,
            icon: "success",
          }).then(() => {
            this.dialogRef.close(true);
          });
        } else {
          Swal.fire({
            title: "Sin cambios",
            html: "<p>No se pudo guardar ningún grupo.</p>",
            icon: "info",
          });
        }
      }
    };
  }

  obtenerAnio(fecha: string, fecha2: string): number {
    const date = new Date(fecha);
    const date2 = new Date(fecha2);
    this.validarAnio = date.getFullYear();
    this.validarAnio2 = date2.getFullYear();
    return this.validarAnio;
  }

  consultarTablaRepetidos(datos: GrupoYears) {
    this.servicioOperativo.ValidarRegistrosRepetidos(datos).subscribe((res) => {
      if (res.pCodRetorno !== "00000") {
        const swalWithBootstrapButtons = Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success",
          },
          buttonsStyling: false,
        });
        swalWithBootstrapButtons.fire({
          title: "Alerta",
          html:
            "<p>No es posible realizar la accion. </p> " +
            "<p> Ya se encuentra registrado un grupo con ese nombre.</p>",
          icon: "error",
          showCancelButton: false,
          confirmButtonText: "Continuar",
          reverseButtons: true,
        });
      } else {
        this.servicioOperativo.saveGrupoYears(datos).subscribe((resp) => {
          if (resp.pCodRetorno === "00000") {
            const swalWithBootstrapButtons = Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success",
              },
              buttonsStyling: false,
            });
            swalWithBootstrapButtons
              .fire({
                title: "Alerta",
                html: "<p>  El grupo se ha guardado correctamente  </p>",
                icon: "success",
                showCancelButton: false,
                confirmButtonText: "Aceptar",
                reverseButtons: true,
              })
              .then((result) => {
                if (result.isConfirmed) {
                  this.dialogRef.close(resp);
                  this.clear();
                }
              });
          } else {
            var mensaje =
              "<p> No se puedo crear el grupo. " +
              (resp.pCodRetorno.startsWith("244")
                ? resp.pMensaje + " </p>"
                : "</p>");

            const swalWithBootstrapButtons = Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success",
              },
              buttonsStyling: false,
            });
            swalWithBootstrapButtons.fire({
              title: "Alerta",
              html: mensaje,
              icon: "error",
              showCancelButton: false,
              confirmButtonText: "Aceptar",
              reverseButtons: true,
            });
          }
        });
      }
    });
  }
}
